<template>
    <div class="title-style-one mb-3 container pt-80">
        <h2 class="titre-section pb-50">
            Choisissez maintenant<br />
            <span class="span-background">
                votre mode d’inscription !
            </span>
        </h2>
        <div class="box-card">
            <div class="row">
                <div class="col-md-4">
                    <div class="offre-emploi">
                        <a href="tel:0562471909">
                            <i class="fa-light fa-mobile fa-3x"></i>
                            <div class="box-content">
                                <p class="title  mb-2">
                                    05 62 47 19 09
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="offre-emploi">
                        <a href="mailto:admin@emciconseil.fr">
                            <i class="fa-light fa-envelope-open-text fa-3x"></i>
                            <div class="box-content">
                                <p class="title  mb-2">
                                    admin@emciconseil.fr
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="offre-emploi">
                        <a href="/contactez-nous">
                            <i class="fa-light fa-globe fa-3x"></i>
                            <div class="box-content">
                                <p class="title  mb-2">
                                    emciconseil.fr
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
</script>

<style scoped>
.offre-emploi {
    grid-area: auto;
    border-radius: 9px;
    border: 2px solid var(--zinc-100, #EEF5FA);
    background: var(--zinc-0, #FFF);
    transition: transform 0.5s ease, box-shadow 0.5s ease;
}

.offre-emploi {
    margin: 1rem;
    padding: 20px;
    border-radius: 0.5625rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
}


.box-card {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    justify-content: center;
    gap: 40px;
    padding: 0px 50px;
    margin-top: 30px !important;
}

.box-content p {
    text-align: center;
    color: var(--accent, #25233E);
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    letter-spacing: 0.72px;
}



.box-card .offre-emploi {
    margin: 1rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 30px;
    border-radius: 0.5625rem;
}

.box-card .offre-emploi:hover {
    background: linear-gradient(93deg, #318EC7 9.92%, #E94B54 52.75%, #FAB74B 88.05%);
}

.box-card .offre-emploi:hover i {
    color: white !important;
}


.box-card .offre-emploi:hover .sous-titre,
.box-card .offre-emploi:hover .title {
    color: #fff;
}

.offre-emploi:hover svg path {
    fill: #FFF !important;
}

.box-card img {
    max-width: 60px;
}
</style>